import { render, staticRenderFns } from "./SendReminderAction.vue?vue&type=template&id=6a3a9bfc"
import script from "./SendReminderAction.vue?vue&type=script&lang=js"
export * from "./SendReminderAction.vue?vue&type=script&lang=js"
import style0 from "./SendReminderAction.vue?vue&type=style&index=0&id=6a3a9bfc&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports